import K from "./constants";
import restHelpers from "../helpers/restHelper";

const getAsset = (imei) => {
    const url = K.API_URL + `/api/v1/munic/assets/${imei}`;
    return restHelpers.withBearer.get(url, {});
};

export default {
    getAsset
};



// WEBPACK FOOTER //
// ./src/services/assets.js